import React from 'react';
import { Navbar, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const MeancLogo = () => (
  <div className="meanc-logo">
    <div className="meanc-logo-icon">
      <span>M</span>
      <span>E</span>
    </div>
    <div className="meanc-logo-type">
      <strong>MEANC</strong>
      <small>modern cloud</small>
    </div>
  </div>
);

export default function Header5() {
  return (
    <Navbar
      expand={false}
      bg="light"
      className="custom-navbar align-items-left fixed-top"
      style={{ boxShadow: '0px 5px 10px rgba(0, 0, 0, 0.1)' }}
    >
      <Container>
        <Navbar.Brand style={{ marginLeft: '10px' }}>
          <Link to="/" className="meanc-logo-link">
            <MeancLogo />
          </Link>
        </Navbar.Brand>
      </Container>
    </Navbar>
  );
}
